import React from 'react';
import { useNavigate } from 'react-router-dom';
import detectEthereumProvider from '@metamask/detect-provider';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../src/style/Home.css';
import Web3 from 'web3';
const contractDOC = require("./EmployeeDocumentManagement.json");
const DOCABI = contractDOC.abi;
const AdvancedEmployeeDocumentManagementADDRESS = process.env.REACT_APP_CONTRACT_ADDRESS;
const Home = () => {
    const navigate = useNavigate();

    const checkRoleAndNavigate = async (role) => {
        const provider = await detectEthereumProvider();
        if (provider) {
            const web3 = new Web3(provider);
            const contract = new web3.eth.Contract(DOCABI, AdvancedEmployeeDocumentManagementADDRESS);
            try {
                const accounts = await provider.request({ method: 'eth_requestAccounts' });
                const walletAddress = accounts[0];
                // Check network ID
                const networkId = await web3.eth.net.getId();
                if (Number(networkId) !== 80002) { // 80002 is the network ID for Polygon Mumbai testnet
                    try {
                        // Prompt user to switch to the correct network
                        await provider.request({
                            method: 'wallet_switchEthereumChain',
                            params: [{ chainId: Web3.utils.toHex(80002) }],
                        });
                    } catch (switchError) {
                        // If the network is not added, prompt the user to add it
                        if (switchError.code === 4902) {
                            await provider.request({
                                method: 'wallet_addEthereumChain',
                                params: [{
                                    chainId: Web3.utils.toHex(80002),
                                    chainName: 'Polygon Amoy Testnet',
                                    rpcUrls: ['https://rpc-amoy.polygon.technology'],
                                    nativeCurrency: {
                                        name: 'MATIC',
                                        symbol: 'MATIC',
                                        decimals: 18,
                                    },
                                    blockExplorerUrls: ['https://www.oklink.com/amoy'],
                                }],
                            });
                        } else {
                            console.error('Failed to switch or add network:', switchError);
                            toast.error('Failed to switch or add network. Please switch to the Polygon Mumbai testnet.');
                        }
                    }
                    return; // Stop execution if network is incorrect
                }

                let roleConstant;
                switch (role) {
                    case 'employee':
                        roleConstant = await contract.methods.EMPLOYEE_ROLE().call();
                        break;
                    case 'admin':
                        roleConstant = await contract.methods.ADMIN_ROLE().call();
                        break;
                    case 'verifier':
                        roleConstant = await contract.methods.APPROVER_ROLE().call();
                        break;
                    default:
                        throw new Error("Unknown role");
                }
                if (roleConstant) {
                    const hasRole = await contract.methods.hasRole(roleConstant, walletAddress).call();
                    if (hasRole) {
                        navigate(`/${role}`, { state: { walletAddress } });
                    } else {
                        toast.error("You do not have the required role to access this page.");
                        navigate('/');
                    }
                } else {
                    navigate('/owner', { state: { walletAddress } });
                }
            } catch (error) {
                console.error('Error during role check or navigation:', error);
                toast.error("Check your Role and try again.");
                navigate('/');
            }
        } else {
            console.error('MetaMask is not installed.');
            toast.error('MetaMask is not installed. Please install MetaMask and try again.');
        }
    };

    return (
        <div className="home-container"><br></br><br></br><br></br> <br></br><br></br>
            <h1 className="home-title">Employee Document Management System</h1>
            <div className="button-container">
                <button className="button employee" onClick={() => checkRoleAndNavigate('employee')}>
                    Employee
                </button>
                <button className="button admin" onClick={() => checkRoleAndNavigate('admin')}>
                    Admin
                </button>
                <button className="button verifier" onClick={() => checkRoleAndNavigate('verifier')}>
                    Verifier
                </button>
                {/* <button className="button owner" onClick={() => checkRoleAndNavigate('owner')}>
                    Owner
                </button> */}
            </div>
            <ToastContainer />
        </div>
    );
};

export default Home;
